import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React from "react";

const useStyles = makeStyles((theme) => ({
  body: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.up("lg")]: {
      marginLeft: "5%",
      // marginBottom: theme.spacing(10),
    },
  },
  summary: {
    color: theme.palette.secondary.main,
    textTransform: "uppercase",
  },
}));

export default function YoozAccordion(props) {
  const { id, summary, children, defaultExpanded } = props;
  const classes = useStyles();

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={id + "-content"}
        id={id + "-header"}
      >
        <Typography variant={"body1"}>
          <span className={classes.summary}>{summary}</span>
        </Typography>
      </AccordionSummary>
      <Divider variant="middle" />
      <AccordionDetails className={classes.body}>
        <Typography variant={"body2"}> {children} </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
